<h2 mat-dialog-title>{{ 'CONTACT.PROFILE_PAGE.MEETING_EVENT_LIST_TITLE' | translate }}</h2>
<mat-dialog-content>
  @if (loading$$ | async) {
    <glxy-loading-spinner></glxy-loading-spinner>
  } @else {
    <mat-radio-group [(ngModel)]="selectedMeetingType">
      <div class="card-container">
        @for (meeting of meetingTypes; track meeting) {
          <div class="card-item">
            <mat-card [ngClass]="{ 'selected-card': meeting.id | isSelected: selectedMeetingType }">
              <mat-card-content>
                <mat-radio-button [value]="meeting.id">{{ meeting.name }}</mat-radio-button>
                <div class="badge-with-duration">
                  <p>{{ meeting.duration | duration }}</p>
                  <glxy-badge [color]="getBadgeColor(meeting.CalendarType)">
                    {{ getEventType(meeting.CalendarType) }}
                  </glxy-badge>
                </div>
                @if (meeting.teamName) {
                  <div class="badge">
                    <glxy-badge
                      [color]="getBadgeColor(meeting.teamName)"
                      [matTooltip]="meeting.teamName"
                      matTooltipPosition="above"
                      >
                      {{ getTruncatedTeamName(meeting.teamName) }}
                    </glxy-badge>
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    </mat-radio-group>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <ng-container>
    <button mat-stroked-button class="event-cancel-button" (click)="close()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>
    <button mat-flat-button class="event-send-button" color="primary" cdkFocusInitial (click)="sendEmail()">
      {{ 'ACTIONS.SEND' | translate }}
    </button>
  </ng-container>
</mat-dialog-actions>
